import './style.scss';
import React, { memo, useState } from 'react';
import Button from '../button/Button';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Skeleton, ProgressBar } from '@studygo/frontend-components';

const EmptyState = ({
	image,
	title,
	description,
	handleOnClick,
	btnTitle,
	btnType,
	btnColor = '',
	btnIcon = 'add',
	hideIcon = false,
	label,
	className,
	showExtraBtn = false,
	extraBtnTitle,
	extraBtnIcon,
	extraBtnOnClick,
	showProgress,
	progress,
	customAction,
	loading,
	compact,
}) => {
	const [imageLoaded, setImageLoaded] = useState(false);

	return (
		<div
			className={classNames('empty-state', className, {
				compact,
				'loading-img': loading || (image && !imageLoaded),
			})}
		>
			{(loading || !imageLoaded) && <Skeleton type="image" className="skeleton-image" />}
			{image && (
				<img
					src={image}
					onLoad={() => {
						setImageLoaded(true);
					}}
					alt="missingStatement"
				/>
			)}
			<div>
				{(title || loading) && (
					<h3 className="title">
						{loading ? <Skeleton type="title" className="skeleton-title" /> : title}
					</h3>
				)}
				{(description || loading) && (
					<div className="description">
						{loading ? <Skeleton type="desc" className="skeleton-desc" /> : description}
					</div>
				)}
				{showProgress && !loading && <ProgressBar lineSize="medium" value={progress} />}
				<div className="actions">
					{handleOnClick && (
						<Button
							type={btnType || 'primary'}
							className="empty-state-btn"
							color={btnColor}
							title={btnTitle}
							iconName={!hideIcon ? btnIcon : null}
							onClick={loading ? undefined : handleOnClick}
							label={label}
						/>
					)}
					{customAction}
					{showExtraBtn && (
						<Button
							iconName={extraBtnIcon}
							className="extra-btn purple"
							type="link"
							title={extraBtnTitle}
							onClick={loading ? undefined : extraBtnOnClick}
						/>
					)}
				</div>
			</div>
		</div>
	);
};

EmptyState.propTypes = {
	btnTitle: PropTypes.string,
	image: PropTypes.string,
	btnIcon: PropTypes.string,
	title: PropTypes.string,
	description: PropTypes.string,
	handleOnClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
	hideIcon: PropTypes.bool,
	className: PropTypes.string,
	showProgress: PropTypes.bool,
	progress: PropTypes.number,
};

export default memo(EmptyState);
